<template>
  <div class="view-container home">
    <div class="extended-filter-block">
      <h2>Моя компания</h2>
    </div>
    <dashboard-grid
      :referenceProfileAlignment="companyActivityData?.reference_profile_alignment ?? []"
      :dataAnalytics="dataAnalytics?.value ?? []"
      :userStats="usersStats ?? {}"
      :energy="companyActivityData?.energy_score"
      :softSkills="companyActivityData?.soft_skills_score"
      :fatigueScore="companyActivityData?.chronic_fatigue_level"
      :avgEi="companyActivityData?.avg_ei"
      :managementScale="companyActivityData?.management_potential_score"
    />

    <section class="stats-section">
      <div class="home-header">Статистика</div>
      <div class="blocks-container passing-status-container">
        <status-by-passing :type="'test'" />
        <status-by-passing :type="'course'" />
      </div>
    </section>

    <section class="blocks-container">
      <DashboardProductTables :tableData="data.value" @showOrderForm="showOrderForm = true" @showManageAccessForm="showManageAccessForm = true" />
    </section>



    <news-community/>

    <NewOrderForm v-if="showOrderForm" :open="showOrderForm" @close="showOrderForm = false" />
    <ManageAccessForm v-if="showManageAccessForm"
                      :open="showManageAccessForm"
                      @close="showManageAccessForm = false"
                      @submitted="() => {
                        loadSummary();
                        showManageAccessForm = false
                      }"
                      @showOrderForm="() => {
                        showManageAccessForm = false;
                        showOrderForm = true;
                      }"
                      @showStaff="() => router.push('/staff')"
                      :userData="[]"
                      :mode="'staff'"
    />

    <ReferenceInfoModal
      v-if="referenceProfileToShow"
      :open="referenceProfileToShow !== null"
      :profileId="referenceProfileToShow"
      @close="referenceProfileToShow = null"
    />
  </div>
</template>

<script>
import {computed, onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import useCheckRights from "@/mixins/useCheckRights";
import reports from "@/mixins/dictionaries/reports";
import {useStore} from "vuex";
import PopUpForm from "@/components/Popups/PopUpForm";
import NewsCommunity from "@/components/Cards/NewsCommunity.vue";
import { PlusCircleOutlined, MinusCircleOutlined, RightOutlined } from '@ant-design/icons-vue'
import {h} from 'vue'
import { PlusOutlined } from '@ant-design/icons-vue';
import StatusByPassing from "@/components/Cards/StatusByPassing.vue";
import getReportName from "@/mixins/getReportName";
import DashboardProductTables from "@/components/DashboardProductTables/DashboardProductTables.vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import {useRouter} from "vue-router";
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";
import ReferenceInfoModal from "@/feature/references/ReferenceInfoModal.vue";
import DashboardGrid from "@/components/Widgets/Dashboard/DashboardGrid.vue";

export default {
  components: {
    DashboardGrid,
    ReferenceInfoModal,
    ManageAccessForm,
    NewOrderForm,
    StatusByPassing,
    NewsCommunity,
    PopUpForm,
    PlusCircleOutlined,
    MinusCircleOutlined,
    RightOutlined,
    PlusOutlined,
    DashboardProductTables
  },
  name: "home",
  setup() {
    const store = useStore(),
        {getRight} = useCheckRights(),
        router = useRouter();

    const profile = computed(() => store.state.profile.profile),
        companyActivityData = computed(() => store.state.companyActivity);

    const showMoreAlignedUsers = ref(false);
    const showMoreAverageScores = ref(false);

    const dataAnalytics = reactive({value: []});
    const usersStats = ref({});
    const topReferenceProfile = ref([]);

    const referenceProfileToShow = ref(null);

    const columnsAnalytics = [
      {
        title: 'Группа',
        dataIndex: 'group',
        key: 'group',
        align: 'left',
      },
      {
        title: 'Средний ЭИ',
        dataIndex: 'average',
        key: 'average',
        align: 'center',
        customRender: ({ record }) => {
          const average = record.average;

          const getStyles = (average) => {
            if (average > 100) {
              return {
                borderColor: '#B7EB8F',
                backgroundColor: '#F6FFED',
                textColor: '#52C41A',
              };
            } else if (average >= 80 && average <= 100) {
              return {
                borderColor: '#FFD591',
                backgroundColor: '#FFF7E6',
                textColor: '#FA8C16',
              };
            } else {
              return {
                borderColor: '#FFA39E',
                backgroundColor: '#FFF1F0',
                textColor: '#F5222D',
              };
            }
          };

          const style = getStyles(average);

          return h(
              'div',
              {
                class: 'Analytics-counter',
                style: {
                  border: `1px solid ${style.borderColor}`,
                  backgroundColor: style.backgroundColor,
                  color: style.textColor,
                },
              },
              average.toString()
          );
        },
      },
    ];

    const data = reactive({value: []});
    const showOrderForm = ref(false);
    const showManageAccessForm = ref(false);

    onBeforeMount(() => {
      loadSummary();
    });

    const loadSummary = () => {
      store.commit("setIsGlobalLoad", true);

      store.dispatch('getCompanyActivity').then(() => {
        let profilesArray = [];

        companyActivityData.value?.reference_profile_alignment?.map((element) => {
            element.users.map((subElement) => {
                profilesArray.push({
                  profile: element.title,
                  profileId: element.reference_profile_id,
                  name: subElement.name,
                  conform: subElement.aligned,
                  userId: subElement.user_id,
                })
            })
        });

        topReferenceProfile.value = profilesArray;

        dataAnalytics.value = companyActivityData.value?.groups?.map((el) => {
            return {
              group: el.name,
              average: el.average_passing_score,
            }
        }).filter((el) => {
          return el.average > 0
        }).sort((a, b) => b.average - a.average);

        usersStats.value = {
          total: { title: 'Всего добавлено', count: companyActivityData.value?.user_counts?.total_count ?? 0, link: '/staff', type: 'staff'},
          group:  { title: 'Групп создано', count: companyActivityData.value?.groups?.length ?? 0, link: '/groups', type: 'groups'},
          archive:  { title: 'В архиве', count: companyActivityData.value?.user_counts?.blocked_count ?? 0, link: '/staff', type: 'blocked'}
        }

        prepareProducts();

      }).finally(() => {
        store.commit("setIsGlobalLoad", false);
      });
    };

    const prepareProducts = () => {
        let courseActivitySummary = companyActivityData.value?.courses?.total_counts ? getCourseActivitySummary(companyActivityData.value?.courses?.total_counts) : [];
        let companyTotalPurchased = (companyActivityData.value?.tests?.total_counts?.total?.issued_users_count ?? 0) + (companyActivityData.value?.tests?.total_counts?.total?.free_count ?? 0)
        let subscriptionData = companyActivityData.value?.subscription ? getCompanySubscriptionSummary(companyActivityData.value?.subscription): [];

        data.value =
          {
            tests: {
              id: 1,
              product: 'Оценка',
              purchased: companyTotalPurchased,
              issued: companyActivityData.value?.tests?.total_counts?.total?.issued_users_count ?? 0,
              remaining: companyActivityData.value?.tests?.total_counts?.total?.free_count ?? 0,
              completed: companyActivityData.value?.tests?.total_counts?.total?.finished_count ?? 0,
              validUntil: companyActivityData.value?.tests?.total_counts?.total?.closest_expiring_date ?? null,
              timeRemaining: companyActivityData.value?.tests?.total_counts?.total?.remaining_active_days ?? null,
              children: companyActivityData.value?.tests?.total_counts ? getSubTestProducts(companyActivityData.value?.tests?.total_counts) : null,
            },
            courses: {
              id: 2,
              product: 'Развитие',
              purchased: courseActivitySummary?.purchased ?? 0,
              issued: courseActivitySummary?.issued ?? 0,
              remaining: courseActivitySummary?.remaining ?? 0,
              completed: courseActivitySummary?.completed ?? 0,
              validUntil: courseActivitySummary?.validUntil ?? null,
              timeRemaining: courseActivitySummary?.timeRemaining ?? null,
              children: courseActivitySummary?.children ?? null,
            },
            analytics: {
              product: 'Аналитика',
              validUntil: '',
              children: [
                {
                  product: 'Эталонный профиль',
                  has_access: companyActivityData.value?.reference_profiles?.length ? 'Есть' : 'Нет',
                  validUntil: '',
                  timeRemaining: null,
                },
              ],
            },
            subscriptions: subscriptionData?.subscriptions ?? [],
            tools: subscriptionData?.tools ?? [],
          };
    }

    const getSubTestProducts = (array) => {
      let subProductsArray = Object.entries(array)
          .filter(([key]) => key !== 'total')
          .map(([key, value]) => {
            return {
              product: getReportName(key),
              purchased: value.all_count,
              issued: value.issued_users_count,
              remaining: value.free_count,
              completed: value.finished_count,
              validUntil: value.expires_at,
              timeRemaining: value.remaining_active_days,
          }});

      if (!subProductsArray || !subProductsArray.length) {
        return null;
      }

      return subProductsArray;
    }

    const getCourseActivitySummary = (data) => {
       let total = data.find((el) => el.external_id === 'all');

       return {
         purchased: (total?.issued_users_count + total?.free_count),
         issued: total?.issued_users_count,
         remaining: total?.free_count,
         completed: total?.finished_count,
         validUntil: total?.closest_expiring_date,
         timeRemaining: total?.remaining_active_days,
         children: getSubCourseProducts(data),
       }
    }

      const openConsultModal = ref(false)
      const showConsultModal = () => {
      openConsultModal.value = !openConsultModal.value
    }

    const getSubCourseProducts = (array) => {
      let subProductsArray = array.filter((el) => el.external_id !== 'all').map((el) => {
        return {
          product: el.name,
          purchased: el.all_count,
          issued: el.issued_users_count,
          remaining: el.free_count,
          completed: el.finished_count,
          validUntil: el.expiration_date,
          timeRemaining: el.remaining_active_days > 0 ? el.remaining_active_days : null,
        }
      });

      if (!subProductsArray || !subProductsArray.length) {
        return null;
      }

      return subProductsArray;
    }

    let subscriptionTools = [
      {
        id: 1,
        product: 'Дневник эмоций',
        type: 'diary',
        has_access: 'Нет',
        validUntil: '',
        timeRemaining: null,
      },
      {
        id: 3,
        product: 'Навигатор эмоций',
        type: 'tracker',
        has_access: 'Нет',
        validUntil: '',
        timeRemaining: null,
      }
    ];

    const getCompanySubscriptionSummary = (data) => {
      let subscriptionData = data.map((subscription) => {
        if (subscription.instruments.length) {
          subscription.instruments.forEach((instrument) => {
             let tool = subscriptionTools.find((el) => el.type === instrument);
             tool.has_access = 'Есть';
             tool.validUntil = subscription.expired_at;
             tool.timeRemaining = subscription.active_days_remaining;
          });
        }

        return {
          product: subscription.title,
          has_access: 'Есть',
          validUntil: subscription.expired_at,
          timeRemaining: subscription.active_days_remaining,
        }
      });

      return {
        subscriptions: subscriptionData,
        tools: subscriptionTools,
      }
    }

    watch(
        () => profile.value,
        () => {
          if (profile.value && profile.value.role && (getRight('staff') || getRight('private_person'))) {
              router.push('/personal');
          }
        }
    );

    return {
      router,
      getRight,
      reports,
      profile,
      openConsultModal,
      showConsultModal,
      usersStats,
      data,
      columnsAnalytics,
      dataAnalytics,
      topReferenceProfile,
      showMoreAlignedUsers,
      showMoreAverageScores,
      companyActivityData,
      showOrderForm,
      showManageAccessForm,
      referenceProfileToShow,
      loadSummary
    };
  },
};
</script>

<style scoped lang="scss">
//@use "@/assets/css/breakpoints.scss" as *;
.view-container, .home {
  margin-top: 0;
  padding-top: 0;
}

.block-reference-profile {
  display: flex;
  flex-direction: column;
  font-weight: 600;

  .bottom-button {
    margin-top: auto;
    padding-top: 16px;
  }

  .add-button {
    margin: 0;
    align-self: flex-start;
  }
}

.status-header {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  color: var(--main-font);
}

.home-header {
  margin-bottom: 20px;
  font-size: 20px;
  text-align: left;
  font-weight: 500;
}

.profile-item {
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
  align-items: baseline;
}

.profile-name {
  color: var(--main-green);
  font-weight: 600;
  cursor: pointer;
}

.profile-name:hover {
  color: var(--main-green);
}

.profile-text {
  color: var(--neutral-black-font);
  word-spacing: 4px;
}

.reference-name {
  text-decoration: underline;
  cursor: pointer;
}

.analytics-table {
  margin-bottom: 10px;
}

.ant-table-thead > tr > th {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  background-color: #fafafa;
}

.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 8px;
  font-size: 14px;
}

.ant-table-tbody > tr > td:first-child {
  text-align: left;
}

 .home {
   .blocks-container {
     display: flex;
     gap: 16px;
     width: 100%;
     flex-wrap: wrap;
     margin-bottom: 16px;
     text-align: left;
   }

   @media (max-width: $tablet-breakpoint) {
     .blocks-container:not(.passing-status-container) .content-block,
     .blocks-container:not(.passing-status-container) > * {
       flex-basis: 100%;
       max-width: 100%;
     }
   }

   .content-block {
     flex: 1;
     min-width: 280px;
     background: #fff;
     padding: 20px;
     border-radius: 8px;
     font-size: 14px;

     .count {
       margin-top: 8px;
       color: var(--main-green);
       font-size: 16px;
       font-weight: 600;
       cursor: pointer;
     }

     .count:hover {
       color: var(--hover-green);
     }
   }
 }

 .add-button {
   background-color: #fff;
 }

 .add-button:hover {
   background-color: var(--polar-green);
   border-color: var(--main-green);
   color: var(--main-green);
 }

 .products-wrapper {
   display: flex;
   flex-direction: column;
   row-gap: 15px;
   padding: 20px;
   background: #fff;
   border-radius: 8px;
   max-width: 1170px;
 }

 .add-product-button {
   margin-top: 10px;
   display: flex;
   justify-content: space-between;
   column-gap: 15px;

   @media (max-width: $tablet-breakpoint) {
     flex-direction: column;
     row-gap: 5px;
   }
 }

 .users-section {
   margin-top: 20px;
 }

 .users-container {
   @media (max-width: 1235px) {
     .content-block {
       max-width: 30%;
       min-width: 30%;
     }
   }
 }

 :deep(.block-days-left) {
   margin-top: 8px;
   padding: 4px 8px;
   border-radius: 6px;
   font-size: 12px;
   text-align: center;
   min-width: 120px;
   line-height: 1.4;
 }

 :deep(.analytics-table .ant-table-cell) {
   padding: 10px 8px !important;
 }

:deep(.analytics-table) {
  .ant-table-row .ant-table-cell:nth-child(2) {
    text-align: right !important;
  }
}

 :deep(.analytics-counter) {
   display: inline-block;
   padding: 1px 8px;
   border-radius: 6px;
   min-width: 37px;
   text-align: center;
   font-size: 12px;
 }

 .no-data-wrapper {
   padding: 30px 0;
   text-align: center;
 }

 .no-data-image {
   width: 100px;
   margin-bottom: 16px
 }

 .no-data-text {
   color: var(--main-font);
   font-size: 16px;
 }

 .stats-section {
   margin-top: 16px;
 }

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}
</style>